module.exports = __webpack_public_path__ + "media/images/collapse-arrow-red-a6317d0a10db92a0b288ba9013a297b4.png";